export const employeeListData = [
  {
img:"user-32.jpg",
    ID: "EMP001",
    Employee: "Carl Evans",
    Designation: "Designer",
    Email: "carlevans@example.com",
    Phone: "+12163547758",
    Shift: "Regular",
    Status: "Active",
  },
  {
img:"user-02.jpg",
    ID: "EMP002",
    Employee: "Minerva Rameriz",
    Designation: "Administrator",
    Email: "rameriz@example.com",
    Phone: "+11367529510",
    Shift: "Regular",
    Status: "Active",
  },
  {
img:"user-01.jpg",
    ID: "EMP003",
    Employee: "Robert Lamon",
    Designation: "Developer",
    Email: "robert@example.com",
    Phone: "+15362789414",
    Shift: "Regular",
    Status: "Active",
  },
  {
img:"user-04.jpg",
    ID: "EMP004",
    Employee: "Patricia Lewis",
    Designation: "HR Manager",
    Email: "patricia@example.com",
    Phone: "+18513094627",
    Shift: "Night Shift",
    Status: "Active",
  },
  {
img:"user-08.jpg",
    ID: "EMP005",
    Employee: "Mark Joslyn",
    Designation: "Designer",
    Email: "markjoslyn@example.com",
    Phone: "+14678219025",
    Shift: "Mid Shift",
    Status: "Active",
  },
  {
img:"user-10.jpg",
    ID: "EMP006",
    Employee: "Marsha Betts",
    Designation: "Developer",
    Email: "marshabetts@example.com",
    Phone: "+10913278319",
    Shift: "Mid Shift",
    Status: "Active",
  },
  {
img:"user-28.jpg",
    ID: "EMP007",
    Employee: "Daniel Jude",
    Designation: "Administrator",
    Email: "daieljude@example.com",
    Phone: "+19125852947",
    Shift: "Regular",
    Status: "Active",
  },
  {
img:"user-17.jpg",
    ID: "EMP008",
    Employee: "Emma Bates",
    Designation: "HR Assistant",
    Email: "emmabates@example.com",
    Phone: "+13671835209",
    Shift: "Regular",
    Status: "Active",
  },
  {
img:"user-20.jpg",
    ID: "EMP009",
    Employee: "Richard Fralick",
    Designation: "Designer",
    Email: "richard@example.com",
    Phone: "+19756194733",
    Shift: "Regular",
    Status: "Active",
  },
  {
img:"user-29.jpg",
    ID: "EMP010",
    Employee: "Michelle Robison",
    Designation: "HR Manager",
    Email: "robinson@example.com",
    Phone: "+19167850925",
    Shift: "Regular",
    Status: "Inactive",
  },
];
